// Feature Code → Human-Readable Label + Description (TR + EN)
// Backend'den gelen özellik kodlarını kullanıcı dostu etiketlere çevirir.
// Ultra Admin > Özellik Yönetimi ile aynı kodları kullanır.
//
// Not: İleride bu tanımlar Ultra Admin üzerinden yönetilebilir hale getirilebilir.
// Şimdilik static kaynak — tek doğruluk merkezi.

const LABELS = {
  // Avans akışı
  new_advance_request: {
    tr: { label: 'Avans talebi oluşturma',
          desc: 'Çalışanlar mobil veya web üzerinden avans talebi oluşturabilir; miktar, tarih ve açıklama girer.' },
    en: { label: 'Create advance request',
          desc: 'Employees create advance requests via mobile or web with amount, date and description.' },
  },
  advance_approval: {
    tr: { label: 'Yönetici onay süreci', desc: 'Departman yöneticileri gelen avans taleplerini inceler, onaylar veya reddeder.' },
    en: { label: 'Manager approval flow', desc: 'Department managers review, approve or reject incoming advance requests.' },
  },
  finance_approval: {
    tr: { label: 'Finans onayı', desc: 'Yönetici onayından sonra finans ekibi son onayı verir ve ödemeyi başlatır.' },
    en: { label: 'Finance approval', desc: 'After manager approval, finance team gives final approval and initiates payment.' },
  },
  advance_closing: {
    tr: { label: 'Avans kapatma', desc: 'Kullanıcı harcamalarını fişleriyle girer; kalan/fazla otomatik hesaplanır ve avans kapatılır.' },
    en: { label: 'Advance closing', desc: 'User enters expenses with receipts; remaining/excess auto-calculated and advance is closed.' },
  },
  pending_approvals: {
    tr: { label: 'Bekleyen onaylar', desc: 'Onayınızı bekleyen tüm talepleri tek ekranda görün ve toplu işlem yapın.' },
    en: { label: 'Pending approvals', desc: 'See all requests awaiting your approval on one screen and take bulk actions.' },
  },
  approved_advances: {
    tr: { label: 'Onaylanan avanslar', desc: 'Onaylanmış ancak henüz kapatılmamış avansların takibi.' },
    en: { label: 'Approved advances', desc: 'Track advances that are approved but not yet closed.' },
  },
  closed_advances: {
    tr: { label: 'Kapatılan avanslar', desc: 'Tamamlanmış avansların arşivi — filtreleme, arama, rapor.' },
    en: { label: 'Closed advances', desc: 'Archive of completed advances — filter, search, report.' },
  },
  all_requests: {
    tr: { label: 'Tüm talepler', desc: 'Şirket içindeki tüm avans taleplerinin merkezi görünümü (yetkiye göre).' },
    en: { label: 'All requests', desc: 'Central view of all advance requests in the company (permission-based).' },
  },
  advance_rules: {
    tr: { label: 'Avans kuralları', desc: 'Maksimum tutar, rol bazlı limit, otomatik reddetme kuralları tanımlayın.' },
    en: { label: 'Advance rules', desc: 'Define maximum amounts, role-based limits, auto-reject rules.' },
  },

  // Solo / Harcama
  expense_entry: {
    tr: { label: 'Harcama girişi', desc: 'Fiş fotoğrafı, işletme, kategori ve tutarla hızlı harcama girişi.' },
    en: { label: 'Expense entry', desc: 'Quick expense entry with receipt photo, supplier, category and amount.' },
  },
  personal_expenses: {
    tr: { label: 'Kişisel harcamalar', desc: 'Şirket ve kişisel harcamaları ayrı ayrı takip edin, raporlarda ayrıştırın.' },
    en: { label: 'Personal expenses', desc: 'Track company and personal expenses separately, split in reports.' },
  },
  expense_dashboard: {
    tr: { label: 'Harcama gösterge paneli', desc: 'Aylık toplam, kategori dağılımı, işletme trendleri tek ekranda.' },
    en: { label: 'Expense dashboard', desc: 'Monthly totals, category breakdown, supplier trends on one screen.' },
  },
  expense_reporting: {
    tr: { label: 'Masraf raporlama', desc: 'PDF, Excel, CSV formatında detaylı raporlar; muhasebeciye e-posta ile gönderim.' },
    en: { label: 'Expense reporting', desc: 'Detailed reports in PDF, Excel, CSV; email delivery to your accountant.' },
  },
  current_account: {
    tr: { label: 'Cari hesap takibi', desc: 'Her kullanıcı için otomatik cari hesap: verilen avans - gerçekleşen harcama = bakiye.' },
    en: { label: 'Current account tracking', desc: 'Automatic current account per user: advance given − actual expense = balance.' },
  },

  // Yönetim
  user_management: {
    tr: { label: 'Kullanıcı yönetimi', desc: 'Ekip üyeleri ekleyin, rol ve departman atayın, davetiye gönderin.' },
    en: { label: 'User management', desc: 'Add team members, assign roles and departments, send invitations.' },
  },
  role_hierarchy: {
    tr: { label: 'Rol hiyerarşisi', desc: 'Çok kademeli onay zinciri: Yönetici → Direktör → CFO gibi hiyerarşi kurun.' },
    en: { label: 'Role hierarchy', desc: 'Multi-level approval chain: build hierarchies like Manager → Director → CFO.' },
  },
  category_management: {
    tr: { label: 'Kategori yönetimi', desc: 'Şirketinize özel harcama kategorileri: Yakıt, Yemek, Konaklama, Kırtasiye vb.' },
    en: { label: 'Category management', desc: 'Custom expense categories for your company: Fuel, Meals, Lodging, Stationery, etc.' },
  },
  user_permissions: {
    tr: { label: 'Kullanıcı yetkileri', desc: 'Kullanıcı bazında ekran ve işlem yetkileri: kim neyi görebilir/yapabilir.' },
    en: { label: 'User permissions', desc: 'Per-user screen and action permissions: who can see/do what.' },
  },
  role_permissions: {
    tr: { label: 'Rol izinleri', desc: 'Rol bazında yetki matrisi. Yeni kullanıcı role atandığında yetkileri otomatik gelir.' },
    en: { label: 'Role permissions', desc: 'Permission matrix per role. New users get permissions automatically from role.' },
  },
  general_settings: {
    tr: { label: 'Genel ayarlar', desc: 'Şirket bilgisi, para birimi, zaman dilimi, logo, e-posta imzası gibi ayarlar.' },
    en: { label: 'General settings', desc: 'Company info, currency, timezone, logo, email signature and more.' },
  },

  // İletişim & bildirim
  email_notifications: {
    tr: { label: 'E-posta bildirimleri', desc: 'Yeni talep, onay, red, kapama gibi olaylarda otomatik e-posta bildirimi.' },
    en: { label: 'Email notifications', desc: 'Automatic email notifications for new requests, approvals, rejections, closings.' },
  },
  whatsapp_integration: {
    tr: { label: 'WhatsApp entegrasyonu', desc: 'Onay bildirimleri WhatsApp üzerinden anında ulaşır; onaylar mobil olarak verilebilir.' },
    en: { label: 'WhatsApp integration', desc: 'Approval notifications delivered instantly via WhatsApp; approve on mobile.' },
  },
  messaging: {
    tr: { label: 'Mesajlaşma', desc: 'Talep içi yorum ve mesajlaşma — tüm iletişim tek yerde arşivlenir.' },
    en: { label: 'Messaging', desc: 'In-request comments and messaging — all communication archived in one place.' },
  },

  // Verimlilik & rapor
  bulk_operations: {
    tr: { label: 'Toplu işlemler', desc: 'Birden fazla talebi tek tıkla onayla, sil, dışa aktar; büyük ekipler için verimlilik.' },
    en: { label: 'Bulk operations', desc: 'Approve, delete, export multiple requests in one click; productivity for large teams.' },
  },
  advanced_filtering: {
    tr: { label: 'Gelişmiş filtreleme', desc: 'Tarih aralığı, işletme, kategori, tutar, kullanıcı, durum — çoklu kriter kombinasyonu.' },
    en: { label: 'Advanced filtering', desc: 'Date range, supplier, category, amount, user, status — multi-criteria combinations.' },
  },
  excel_export: {
    tr: { label: 'Excel dışa aktarma', desc: 'Filtrelenmiş verileri .xlsx dosyası olarak indir; muhasebe defterine hazır.' },
    en: { label: 'Excel export', desc: 'Download filtered data as .xlsx file; ready for accounting ledgers.' },
  },
  pdf_export: {
    tr: { label: 'PDF dışa aktarma', desc: 'Kurumsal görünümlü PDF raporlar; logo, imza ve rapor başlığı ile.' },
    en: { label: 'PDF export', desc: 'Corporate-looking PDF reports; with logo, signature and header.' },
  },
  dashboard_analytics: {
    tr: { label: 'Dashboard & analitik', desc: 'KPI kartları, trend grafikleri, işletme/kategori kırılımları — canlı veri.' },
    en: { label: 'Dashboard & analytics', desc: 'KPI cards, trend charts, supplier/category breakdowns — live data.' },
  },
  mobile_responsive: {
    tr: { label: 'Mobil uyumlu', desc: 'Telefon ve tablet için optimize arayüz — sahada iken talep girip fiş çekebilirsiniz.' },
    en: { label: 'Mobile responsive', desc: 'Optimized UI for phone and tablet — file requests and snap receipts on the go.' },
  },

  // Kurumsal
  api_access: {
    tr: { label: 'API erişimi', desc: 'REST API ile kendi sistemlerinize entegrasyon: SAP, Logo, Netsis, muhasebe yazılımları.' },
    en: { label: 'API access', desc: 'REST API for integrations with your own systems: SAP, Logo, Netsis, accounting software.' },
  },
  custom_branding: {
    tr: { label: 'Özel markalama', desc: 'Şirket logonuz, marka renkleriniz, kendi domaininizden e-postalar.' },
    en: { label: 'Custom branding', desc: 'Your company logo, brand colors, emails from your own domain.' },
  },
  priority_support: {
    tr: { label: 'Öncelikli destek', desc: 'Sıra beklemeden 1 saat içinde yanıt; kritik konularda telefon desteği.' },
    en: { label: 'Priority support', desc: 'Response within 1 hour without waiting; phone support for critical issues.' },
  },
  multi_currency: {
    tr: { label: 'Çoklu para birimi', desc: 'TRY, USD, EUR, GBP + 160 para birimi — otomatik kur ile ana para birimine dönüşüm.' },
    en: { label: 'Multi-currency', desc: 'TRY, USD, EUR, GBP + 160 currencies — auto FX conversion to base currency.' },
  },
  budget_tracking: {
    tr: { label: 'Bütçe takibi', desc: 'Departman ve kategori bazında bütçe belirle; aşımda otomatik uyarı gönder.' },
    en: { label: 'Budget tracking', desc: 'Set budgets per department and category; auto-alert on overruns.' },
  },
};

/**
 * Aktif UI dilini algılar. Şimdilik uygulama Türkçe odaklı, bu yüzden
 * localStorage `app.language` explicit set edilmemişse Türkçe kullanılır.
 * (İleride tam i18n eklendiğinde tarayıcı dilini de yakalarız.)
 */
export function getCurrentLang() {
  try {
    const stored = localStorage.getItem('app.language');
    if (stored === 'tr' || stored === 'en') return stored;
  } catch (_e) {
    /* localStorage okunamıyorsa (SSR/embed) — sessiz geç */
  }
  return 'tr';
}

function _entry(code, lang) {
  const l = lang || getCurrentLang();
  const raw = LABELS[code];
  if (!raw) {
    const pretty = String(code || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    return { label: pretty, desc: '' };
  }
  return raw[l] || raw.tr || raw.en || { label: code, desc: '' };
}

/** Bir feature kodunu insan okunur etikete çevirir. */
export function featureLabel(code, lang) {
  return _entry(code, lang).label;
}

/** Bir feature kodunun uzun açıklamasını döner. Yoksa boş string. */
export function featureDescription(code, lang) {
  return _entry(code, lang).desc || '';
}

/**
 * Feature dizisini {code, label, desc} listesine çevirir. Duplicate ve boşları eler,
 * verilen dile göre alfabetik sıralar.
 */
export function featuresToLabels(codes, lang) {
  const l = lang || getCurrentLang();
  const seen = new Set();
  const out = [];
  for (const c of Array.isArray(codes) ? codes : []) {
    if (!c || seen.has(c)) continue;
    seen.add(c);
    const e = _entry(c, l);
    out.push({ code: c, label: e.label, desc: e.desc });
  }
  out.sort((a, b) => a.label.localeCompare(b.label, l === 'tr' ? 'tr' : 'en'));
  return out;
}

export default { featureLabel, featureDescription, featuresToLabels, getCurrentLang };
